/**
 * `updateMeetingRecording` returns this code (ok=false) when the meeting already has a
 * recording. Nothing changed server-side; resend with `override: true` once the user confirms
 * (see RecordingOverrideDialog).
 */
export const RECORDING_EXISTS = "RECORDING_EXISTS";
